/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for CommissionCtl controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_VERSUSCLIENT, CLIENT_CONTEXT_TOKEN_VERSUSCLIENT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { CommissionDto, RequestOptions } from "../models";

@Injectable({ providedIn: "root" })
export class CommissionCtlService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_VERSUSCLIENT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_VERSUSCLIENT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'VersusClient');
    }

    createCommission(commissionDto: CommissionDto, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    createCommission(commissionDto: CommissionDto, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    createCommission(commissionDto: CommissionDto, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    createCommission(commissionDto: CommissionDto, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/commissions`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: commissionDto,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    updateCommission(commissionDto: CommissionDto, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    updateCommission(commissionDto: CommissionDto, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    updateCommission(commissionDto: CommissionDto, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    updateCommission(commissionDto: CommissionDto, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/commissions`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('put', url, {
            body: commissionDto,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getCommission(idPartner: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<CommissionDto>>;
    getCommission(idPartner: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<CommissionDto>>>;
    getCommission(idPartner: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<CommissionDto>>>;
    getCommission(idPartner: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/commissions/${idPartner}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getDetailsCommission(idCommission: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<CommissionDto>;
    getDetailsCommission(idCommission: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<CommissionDto>>;
    getDetailsCommission(idCommission: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<CommissionDto>>;
    getDetailsCommission(idCommission: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/commissions/details/${idCommission}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
